import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_a3dacc96 from '../styles/List.module.less.js';

/**
 * @description Unordered list element.
 *
 * @component
 * @example
 * ```jsx
 * <UnorderedList>...</UnorderedList>
 * ```
 */
const UnorderedList = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_a3dacc96);
    const classNames = cx(className, 'unordered');
    return (React.createElement("ul", { ref: ref, className: classNames, ...restProps }, children));
});
UnorderedList.displayName = 'UnorderedList';

export { UnorderedList };
//# sourceMappingURL=UnorderedList.js.map
